import * as React from "react";

;
export const ChevronDown = (props: React.SVGProps<SVGSVGElement>) => <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 14.94l8.47-8.47 1.06 1.06L12 17.06 2.47 7.53l1.06-1.06L12 14.94z" fill="#100722" /></svg>;